<template>
  <nav class="nav">
    <label for="toggle">
      <icon :name="hamburger ? 'times' : 'bars'" scale="2"></icon>
    </label>
    <input type="checkbox" id="toggle" v-model="hamburger">
    <div class="container">
      <div class="menu">
        <router-link :to="topNavs[0]">
          <div class="logo"></div>

        </router-link>
        <div class="header-info" v-show="showHeaderInfo">
          <div class="phones">
            <div v-for="(phone, key) in phones" v-bind:key="key" class="phone-item">
              <i class="phone "></i>{{ phone.num }}
            </div>
          </div>
          <div>
            <i class="location "></i>{{ location }}
          </div>
        </div>
        <div class="navbar " v-show="hamburger || windowWidth> 639">
          <ul>
            <li v-for="(value, key) in topNavs" v-bind:key="key">
              <router-link :to="value.url" v-on:click.native="hamburger = !hamburger">{{ value.title }}</router-link>
            </li>
          </ul>
        </div>

        <div class="clearfix"></div>
      </div>
    </div>
  </nav>
</template>
<script>
  import Icon from 'vue-awesome/components/Icon'
  import 'vue-awesome/icons/bars'
  import 'vue-awesome/icons/times'
  export default {
    components: {
      Icon
    },
    props: ['windowWidth'],
    data () {
      return {
        hamburger: false,
        showHeaderInfo: true,
        phones: [{ num: '099 070 50 42' }, { num: '+7 949 346 69 40' }],
        location: 'г.Донецк ул. Ленинградская, 1',
        topNavs: [
          {
            url: '/',
            title: 'Компания'
          },
          {
            url: '/achievments',
            title: 'Достижения'
          },
          {
            url: '/equipments',
            title: 'Оборудование'
          },
          {
            url: '/contacts',
            title: 'Контакты'
          }
        ]
      }
    },
    watch: {
      windowWidth: function (val) {
        if (val > 639) {
          this.hamburger = true
          this.showHeaderInfo = false
          if (val > 991) {
            this.showHeaderInfo = true
          }
        } else {
          this.hamburger = false
          this.showHeaderInfo = true
        }
      }
    }
  }
</script>
<style lang="stylus" scoped>
  @import '../../common/css/vars'

  .phones
    float left

  .phone-item
    display inline-block

    &:nth-of-type(2)
      margin-left 10px

  label
    position absolute
    top 10px
    right 20px
    font-size 26px
    display block
    cursor pointer

  #toggle
    display none

  .header-info
    margin-left 50px
    padding-top 30px

    &:after
      content ''
      display table
      clear both

    div
      text-align left
      font-weight 600
      font-size 10px

      &:nth-of-type(1)
        margin-bottom 10px

      i
        background-position left center
        background-repeat no-repeat
        background-size contain
        padding-left 20px

        &.phone
          background-image url('/static/phone.png')

        &.location
          background-image url('/static/location.png')

  .nav
    box-shadow rgba(62, 62, 62, 0.75) 0px 0px 36px 0px
    position fixed
    top 0
    z-index 2
    width 100%
    background-color $nav-color

  .logo
    display block
    width 89px
    height 73px
    background-image url('/static/logo.png')
    background-repeat no-repeat
    background-size cover
    transform scale(0.8)
    float left

  .menu
    &:after
      content ''
      display table
      clear both

  .navbar
    ul
      display inline-block
      list-style none
      padding-left 0

      li
        display block

        a
          display block
          text-decoration none
          padding 10px 0
          font-weight 600
          font-size 24px
          border-bottom 2px solid transparent

          &:hover
            border-bottom 2px solid $white

          &.router-link-exact-active
            color $red
            border-bottom 2px solid $red

  @media only screen and (min-width: 375px)
    .phone-item:nth-of-type(2)
      margin-left 5px

    .header-info
      padding-top 20px

      div
        font-size 12px

  @media only screen and (min-width: 480px)
    .phones
      float none

    .phone-item:nth-of-type(2)
      margin-left 15px

    .header-info
      margin-left 140px

  @media only screen and (min-width: 640px)
    label
      display none

    .logo, .navbar
      float left

    .header-info
      float right
      margin 0

      &:after
        content none

    .navbar
      display block

      ul
        display inline-block
        list-style none
        padding-left 0
        margin 0

        li
          display inline-block
          margin 0 10px

          a
            display block
            text-decoration none
            padding 29px 0
            font-size 13px
            border-bottom 2px solid transparent

            &:hover
              border-bottom 2px solid $white

  @media only screen and (min-width: 768px)
    .logo
      transform scale(0.9)

    .navbar
      ul
        li
          margin 0 20px

          a
            font-size 14px

  @media only screen and (min-width: 992px)
    .navbar
      ul
        li
          margin 0 10px

          a
            font-size 15px

    .header-info
      padding-top 13px

      div
        font-size 16px

        i
          padding-left 30px
</style>



// WEBPACK FOOTER //
// Header.vue?430ccd7c